<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-accessories"
  >
    <g fill-rule="evenodd">
      <g
        transform="translate(-1044.000000, -374.000000)"
        class="fill"
      >
        <g transform="translate(1044.000000, 374.000000)">
          <path d="M8.319,20.766 L12.298,20.766 L12.298,8.448 L8.319,8.448 L8.319,20.766 Z M6.234,3.66 C6.234,3.374 6.373,3.234 6.66,3.234 L13.957,3.234 C14.244,3.234 14.383,3.374 14.383,3.66 C14.383,3.946 14.244,4.085 13.957,4.085 L6.66,4.085 C6.373,4.085 6.234,3.946 6.234,3.66 L6.234,3.66 Z M18.128,9.297 L17.085,9.297 C16.745,9.297 16.468,9.574 16.468,9.915 L16.468,12 C16.468,12.307 16.696,12.55 16.989,12.598 L16.989,15.648 C16.989,17.722 15.511,19.371 13.532,19.662 L13.532,7.83 C13.532,7.489 13.255,7.213 12.915,7.213 L10.926,7.213 L10.926,5.32 L13.957,5.32 C14.919,5.32 15.617,4.622 15.617,3.66 C15.617,2.698 14.919,2 13.957,2 L6.66,2 C5.698,2 5,2.698 5,3.66 C5,4.622 5.698,5.32 6.66,5.32 L9.691,5.32 L9.691,7.213 L7.702,7.213 C7.362,7.213 7.085,7.489 7.085,7.83 L7.085,21.383 C7.085,21.724 7.362,22 7.702,22 L12.915,22 C13.255,22 13.532,21.724 13.532,21.383 L13.532,20.895 C16.166,20.585 18.224,18.364 18.224,15.648 L18.224,12.598 C18.517,12.55 18.745,12.307 18.745,12 L18.745,9.915 C18.745,9.574 18.469,9.297 18.128,9.297 L18.128,9.297 Z" />
        </g>
      </g>
    </g>
  </svg>
</template>
